module.exports = __webpack_public_path__ + "img/type1_check_2.98330a11.png";